import React from 'react';

import { BrancheDto } from 'lib_api/lib/api/gen';

import FicheDescriptiveForm from '../../FicheDescriptive/FicheDescriptiveForm';

import './Creation.less';

export type CreationProps = {
  callAfterSubmit: () => void | null;
  branche?: BrancheDto;
};

const Creation: React.FC<CreationProps> = ({
  callAfterSubmit,
  branche,
}: CreationProps): React.ReactElement => {
  return (
    <div className={'Creation'}>
      <FicheDescriptiveForm
        onCreationSucceed={callAfterSubmit}
        branche={branche}
      />
    </div>
  );
};

export default Creation;
